var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"projectContent"}},[_c('h3',[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.info.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }